import React from "react";
import { Form, Row, Col, InputGroup } from "react-bootstrap";

interface OfflineScheduleSectionProps {
  startDate: string;
  endDate: string;
  paidAt: string;
  paymentAmount: string;
  onStartDateChange: (v: string) => void;
  onEndDateChange: (v: string) => void;
  onPaidAtChange: (v: string) => void;
  onPaymentAmountChange: (v: string) => void;
  sectionNumber: number;
  disabled?: boolean;
}

const OfflineScheduleSection: React.FC<OfflineScheduleSectionProps> = ({
  startDate,
  endDate,
  paidAt,
  paymentAmount,
  onStartDateChange,
  onEndDateChange,
  onPaidAtChange,
  onPaymentAmountChange,
  sectionNumber,
  disabled,
}) => {
  const minEndDate = !disabled && startDate
    ? (() => {
        const d = new Date(startDate);
        d.setDate(d.getDate() + 1);
        return d.toISOString().split("T")[0];
      })()
    : undefined;

  const endDateInvalid = !disabled && !!(startDate && endDate && endDate <= startDate);

  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">{sectionNumber}</span>
        Schedule &amp; Payment
      </h6>

      <Row className="g-3">
        <Col xs={12} md={3}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Start Date {!disabled && "*"}
          </Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            readOnly={disabled}
            onChange={(e) => !disabled && onStartDateChange(e.target.value)}
          />
        </Col>

        <Col xs={12} md={3}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            End Date {!disabled && "*"}
          </Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            min={minEndDate}
            isInvalid={endDateInvalid}
            readOnly={disabled}
            onChange={(e) => !disabled && onEndDateChange(e.target.value)}
          />
          {endDateInvalid && (
            <Form.Control.Feedback type="invalid">
              End date must be after start date.
            </Form.Control.Feedback>
          )}
        </Col>

        <Col xs={12} md={3}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Paid At {!disabled && "*"}
          </Form.Label>
          <Form.Control
            type="date"
            value={paidAt}
            readOnly={disabled}
            onChange={(e) => !disabled && onPaidAtChange(e.target.value)}
          />
        </Col>

        <Col xs={12} md={3}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Payment Amount (₹) {!disabled && "*"}
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>₹</InputGroup.Text>
            <Form.Control
              type="number"
              placeholder="0"
              min={1}
              value={paymentAmount}
              readOnly={disabled}
              onChange={(e) => !disabled && onPaymentAmountChange(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default OfflineScheduleSection;
